import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { useEffect, useState } from 'react';

export const IncDataSrcEnumSelect = ({ fieldDef, trxSrcCodeToEnumSpecs }) => {
  const { formValues, assignValue } = useForm();

  const [values, setValues] = useState([]);

  useEffect(() => {
    const values = trxSrcCodeToEnumSpecs[formValues.trxSrcCode] ?? [];
    setValues(values);

    if (fieldDef.disabled) return;

    // Only clear this FormField if the new set of possible options does not include the previous value
    if (!values.some((enumSpec) => enumSpec.code === formValues[fieldDef.field])) {
      assignValue(fieldDef.field, null);
    }
  }, [formValues.trxSrcCode]);

  const updatedFormFieldDef = {
    ...fieldDef,
    disabled: fieldDef.disabled || values.length === 0,
    values,
  };

  return <EnumSelect fieldDef={updatedFormFieldDef} />;
};
